import React, { useState } from "react";
import { Table, Row, Col, Card, Button, InputNumber, Popover } from "antd";
import "./Approval_Button.css";
const initialData = [
  {
    key: "01",
    mspc: "KARWAR",
    pusthi: 1.2,
    mlc: 2.3,
    mlcsam: 3,
    mlm: 12,
    upc: 0.8,
    upm: 0.9,
    anc: 20,
    anm: 21,
  },
  {
    key: "02",
    mspc: "KARWAR",
    pusthi: 1.5,
    mlc: 1.3,
    mlcsam: 2,
    mlm: 11,
    upc: 0.6,
    upm: 1.2,
    anc: 18,
    anm: 22,
  },
];

const FG_Report = () => {
  const [dataSource, setDataSource] = useState(
    initialData.map((row) => ({ ...row, overalltotal: calculateTotal(row) }))
  );
  const [editingKey, setEditingKey] = useState(null);
  const [editingField, setEditingField] = useState(null);
  const [editValue, setEditValue] = useState(0);
  const [changeLogs, setChangeLogs] = useState([]);

  function calculateTotal(row) {
    const fields = [
      "pusthi",
      "mlc",
      "mlcsam",
      "mlm",
      "upc",
      "upm",
      "anc",
      "anm",
    ];
    return fields.reduce((sum, field) => sum + (parseFloat(row[field]) || 0), 0);
  }

  const saveEdit = (key) => {
    const newData = [...dataSource];
    const index = newData.findIndex((item) => item.key === key);
    if (index > -1) {
      const oldValue = newData[index][editingField];
      newData[index][editingField] = parseFloat(editValue) || 0;
      newData[index].overalltotal = calculateTotal(newData[index]);
      setDataSource(newData);

      setChangeLogs((prev) => [
        ...prev,
        `MSPC ${newData[index].mspc} → ${editingField.toUpperCase()} changed from ${oldValue} T → ${editValue} T`,
      ]);

      setEditingKey(null);
      setEditingField(null);
    }
  };

  const editableCell = (field) => (value, record) => {
    const isEditing = editingKey === record.key && editingField === field;
    return (
      <Popover
        content={
          <div style={{ display: "flex", flexDirection: "column", gap: 8, minWidth: 170 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8, justifyContent: "center" }}>
              <Button
                size="small"
                onClick={() => setEditValue((prev) => Math.max(0, parseFloat(prev) - 1))}
                style={{ fontWeight: "bold", padding: "0 8px" }}
              >
                -
              </Button>
              <InputNumber
                min={0}
                max={1000}
                step={1}
                value={editValue}
                onChange={setEditValue}
                style={{ width: 70, textAlign: "center" }}
              />
              <Button
                size="small"
                onClick={() => setEditValue((prev) => Math.min(1000, parseFloat(prev) + 1))}
                style={{ fontWeight: "bold", padding: "0 8px" }}
              >
                +
              </Button>
              <span style={{ fontWeight: "bold" }}>T</span>
            </div>
            <Button
              type="primary"
              size="small"
              onClick={() => saveEdit(record.key)}
              style={{ width: "100%" }}
            >
              Save
            </Button>
          </div>
        }
        title={<span style={{ fontWeight: "bold", color: "#1677ff" }}>{`Edit ${field.toUpperCase()}`}</span>}
        trigger="click"
        open={isEditing}
        onOpenChange={(visible) => {
          if (visible) {
            setEditingKey(record.key);
            setEditingField(field);
            setEditValue(record[field] || 0);
          } else {
            setEditingKey(null);
            setEditingField(null);
          }
        }}
      >
        <div style={{ cursor: "pointer" }}>{`${value} T`}</div>
      </Popover>
    );
  };

  const columns = [
    {
      title: "MSPC",
      dataIndex: "mspc",
      key: "mspc",
      render: (text) => (
        <Button
          style={{
            backgroundColor: "#EAFBE7",
            borderRadius: 6,
            color: "#177D35",
            fontWeight: "bold",
            border: "none",
          }}
          size="small"
        >
          {text}
        </Button>
      ),
    },
    { title: "Pushti", dataIndex: "pusthi", key: "pusthi", render: editableCell("pusthi") },
    { title: "MLC", dataIndex: "mlc", key: "mlc", render: editableCell("mlc") },
    { title: "MLC SAM", dataIndex: "mlcsam", key: "mlcsam", render: editableCell("mlcsam") },
    { title: "MLM", dataIndex: "mlm", key: "mlm", render: editableCell("mlm") },
    { title: "UPC", dataIndex: "upc", key: "upc", render: editableCell("upc") },
    { title: "UPM", dataIndex: "upm", key: "upm", render: editableCell("upm") },
    { title: "ANC", dataIndex: "anc", key: "anc", render: editableCell("anc") },
    { title: "ANM", dataIndex: "anm", key: "anm", render: editableCell("anm") },
    {
      title: "OVERALL TOTAL",
      dataIndex: "overalltotal",
      key: "overalltotal",
      render: (v) => (
        <div
          style={{
            backgroundColor: "#EAFBE7",
            color: "#177D35",
            borderRadius: 6,
            textAlign: "center",
            fontWeight: "bold",
            padding: "2px 8px",
          }}
        >
          {v.toFixed(2)} T
        </div>
      ),
    },
  ];

  const cardItems = [
    { key: "pusthi", title: "Pushti", value: dataSource.reduce((sum, r) => sum + r.pusthi, 0) },
    { key: "mlc", title: "MLC", value: dataSource.reduce((sum, r) => sum + r.mlc, 0) },
    { key: "mlcsam", title: "MLC SAM", value: dataSource.reduce((sum, r) => sum + r.mlcsam, 0) },
    { key: "mlm", title: "MLM", value: dataSource.reduce((sum, r) => sum + r.mlm, 0) },
    { key: "upc", title: "UPC", value: dataSource.reduce((sum, r) => sum + r.upc, 0) },
    { key: "upm", title: "UPM", value: dataSource.reduce((sum, r) => sum + r.upm, 0) },
    { key: "anc", title: "ANC", value: dataSource.reduce((sum, r) => sum + r.anc, 0) },
    { key: "anm", title: "ANM", value: dataSource.reduce((sum, r) => sum + r.anm, 0) },
    { key: "overalltotal", title: "OVERALL TOTAL", value: dataSource.reduce((sum, r) => sum + r.overalltotal, 0) },
  ];

  return (
    <div style={{ padding: 20, background: "#F5F7FB" }}>
      <Row gutter={16} align="middle" justify="space-between" style={{ marginBottom: 20 }}>
        <Col>
          <div style={{ color: "#0166B1", fontWeight: "bold" }}>File Name</div>
          <Button
            disabled
            style={{
              border: "1px solid #CCE9FF",
              borderRadius: "5px",
              backgroundColor: "#CCE9FF",
              color: "#0166B1",
              fontWeight: "bold",
            }}
          >
            KTKKAR0825
          </Button>
        </Col>
        <Col>
          <div style={{ color: "#0166B1", fontWeight: "bold" }}>Month</div>
          <Button
            disabled
            style={{
              border: "1px solid #CCE9FF",
              borderRadius: "5px",
              backgroundColor: "#CCE9FF",
              color: "#0166B1",
              fontWeight: "bold",
            }}
          >
            Aug 2025
          </Button>
        </Col>
        <Col>
          <div style={{ color: "#0166B1", fontWeight: "bold" }}>Total Ben.</div>
          <Button
            disabled
            style={{
              border: "1px solid #CCE9FF",
              borderRadius: "5px",
              backgroundColor: "#CCE9FF",
              color: "#0166B1",
              fontWeight: "bold",
            }}
          >
            1234567
          </Button>
        </Col>
        <Col flex="auto" />
        <Col>
          <Button className="btn btn-success">Approve</Button>
          </Col>
        <Col>
         <Button className="btn btn-warning">Hold</Button>
        </Col>
      </Row>

      <Row gutter={10} style={{ marginBottom: 20 }}>
        {cardItems.map((item) => (
          <Col key={item.key}>
            <Card
              style={{
                border: "1px solid #CCE9FF",
                borderRadius: 5,
                backgroundColor: "#CCE9FF",
                minWidth: 100,
                textAlign: "center",
              }}
              bodyStyle={{ padding: 8 }}
            >
              <div style={{ fontWeight: "bold" }}>{item.title}</div>
              <div style={{ color: "#0166B1", fontWeight: "bold" }}>{item.value.toFixed(2)} T</div>
            </Card>
          </Col>
        ))}
      </Row>

    
      <Table columns={columns} dataSource={dataSource} size="small" bordered pagination={false} />

      
      <div style={{ marginTop: 20, padding: 12, backgroundColor: "#F1F1F1", borderRadius: 6, fontSize: 14 }}>
        <b>Changes Made</b>
        {changeLogs.length === 0 ? <div>No changes yet</div> : changeLogs.map((log, i) => <div key={i}>{log}</div>)}
      </div>
    </div>
  );
};

export default FG_Report;
